export const DISEASE_LS_ID = "nuvee_selected_diseases";
export const STRIPE_PRODUCTS_LS_ID = "nuvee_stripe_products";
export const STRIPE_SELECTED_PRODUCT_LS_ID = "nuvee_selected_product";
export const STRIPE_INFO = "stripe_info";
export const BFC_SUFFIX = "_bfc";